export default {"src":"/_next/static/media/chevron_black_to_right.df474617.svg","height":14,"width":8};